export default {
  bind(el, binding, vnode) {
    const input = el.querySelector('input');

    input.addEventListener('focus', function () {
      vnode.context.$nextTick(() => {
        this.select(); // 全选文本
      });
      // 统一转换为数字判断
      // const numericValue = parseFloat(input.value);

      // // 当值为0时执行全选
      // if (numericValue === 0) {
      //   // 使用nextTick确保DOM更新完成
      //   vnode.context.$nextTick(() => {
      //     this.select(); // 全选文本
      //   });
      // }
    });

    // 添加点击事件直接全选（可选）
    input.addEventListener('click', function () {
      if (parseFloat(input.value) === 0) {
        this.select();
      }
    });
  }
};




// WEBPACK FOOTER //
// ./src/utils/clearZero.js